import { mapState } from 'vuex';
import moment from 'moment';
import allowedTimeRangeMixins from './allowedTimeRangeMixins';
export default {
  name: 'CoreDateTimePickerField',
  mixins: [allowedTimeRangeMixins],
  props: {
    label: {
      type: String,
      required: true,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
    dateValue: {
      type: Number,
      required: true
    },
    rules: {
      type: Array,
      required: true
    },
    firstDayOfWeek: {
      type: String,
      required: false,
      default: '1'
    }
  },
  data: function () {
    return {
      pickerDate: null,
      showPickerDialog: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])
  },
  watch: {
    dateValue() {
      this.setupPickerDate();
    }
  },
  created() {
    this.setupPickerDate();
  },
  methods: {
    setupPickerDate() {
      if (new Date(this.dateValue).toString() !== 'Invalid Date') {
        this.pickerDate = moment(new Date(this.dateValue * 1000)).format('YYYY-MM-DD');
      } else {
        this.pickerDate = moment(new Date()).format('YYYY-MM-DD');
      }
    },
    handleDateSelected(isoDateString) {
      this.$emit('date:picked', isoDateString);
    },
    handleDateChanged(value) {
      this.$emit('date:changed', value);
    }
  }
};